import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";

export interface Format {
  FORMAT: string;
  _id: string;
}

interface OptionType {
  value: string;
  label: string;
}
interface SeasonState {
  data: Format[];
  status: string;
  statusCode: number;
  error: string | null;
  isLoading: boolean;
  selectedFormat:string[];
  selectedFormatList:string[];
}
const initialState: SeasonState = {
  data: [],
  status: "",
  error: null,
  statusCode: 0,
  isLoading: false,
  selectedFormat:[],
selectedFormatList:[],
};

export const fetchFormat = createAsyncThunk(
  "fetchFormat",
  async (data:any, { rejectWithValue }) => {
    try {
      const response = await axios.post(API.FETCHFORMAT, data);
      return response;
    } catch (err: any) {
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

const FormatSlice = createSlice({
  name: "FormatData",
  initialState,
  reducers: {
    UpdateSelectedFormat:(state,action)=>{
      state.selectedFormat=action.payload
    },
    UpdateSelectedFormatList:(state,action)=>{
      state.selectedFormatList=action.payload
    },
        emptyFormatReducer:(state) => {
          state.data = initialState.data;
          state.status = initialState.status;
          state.error = initialState.error;
          state.statusCode = initialState.statusCode;
          state.isLoading = initialState.isLoading;
          state.selectedFormat = initialState.selectedFormat;
          state.selectedFormatList = initialState.selectedFormatList;
        }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchFormat.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(fetchFormat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        state.data = action.payload.data;
      })
      .addCase(fetchFormat.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      });
  },
});
export const {UpdateSelectedFormat, UpdateSelectedFormatList,emptyFormatReducer} = FormatSlice.actions;
export default FormatSlice.reducer;
